import { Database } from '@phosphor-icons/react';
import { Collections } from './Collections';

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("collections")) return [];
    return [
      {
        label: "Collections",
        icon: <Database className="text-lg" />,
        href: "/collections",
        order: 8,
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("collections")) return [];
    return [
      {
        path: "/collections",
        element: <Collections name="Collections" />,
        children: [
          {
            path: ":id",
            element: <Dashboard name="Collections" />,
          },
        ],
      },
    ];
  }
};


export { Collections };